<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row class="ma-0">
    <template>
      <v-dialog v-model="dialogUsrMsg" width="500px" scrollable >
          <v-card class="grey lighten-3">
              <v-toolbar class="primary" dark text>
                  <div class="text-h6">{{ $t('general.seeMessage') }}</div>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="dialogUsrMsg = false">
                    <v-icon>clear</v-icon>
                  </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-row v-if="selectedUserSentMessage.message">
                  <v-col cols="12" v-if="selectedUserSentMessage.name">{{ $t('general.youAreSeeingTheMessageOf') }} <span class="font-weight-bold">{{selectedUserSentMessage.name}}</span>.</v-col>
                  <v-card
                    class="mt-4"
                    width="-webkit-fill-available">
                    <v-card-text v-if="selectedUserSentMessage.message">{{selectedUserSentMessage.message}}</v-card-text>
                  </v-card>
                  <v-col class="mt-4" cols="12" >
                    <v-chip color="primary white--text" v-if="selectedUserSentMessage.info && selectedUserSentMessage.info.calculatedMultiparts">
                      {{ $tc('general.messagePart', 1) }}: {{selectedUserSentMessage.info.calculatedMultiparts}}
                    </v-chip>
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col cols="12">{{ $t('general.noUserDefinedMessage') }}</v-col>
                </v-row>
              </v-card-text>
              <v-divider/>
              <v-card-actions>
                  <v-spacer/>
                  <v-btn v-if="dialogUsrMsg"
                         color="red"
                         text
                         @click="dialogUsrMsg = false">
                      {{ $t('general.close') }}
                  </v-btn>
              </v-card-actions>
          </v-card>
      </v-dialog>
    </template>
    <v-col cols="12" class="text-h6">
      <v-data-table class="elevation-2"
                    :headers="type === 'massive' ? smsMassiveHeaders : defaultHeaders"
                    :items="items"
                    :options.sync="optionsValue"
                    :footer-props="{
                      'items-per-page-text': `${$t('general.people')} ${$t('general.perPage')}`,
                      'items-per-page-options': [50, 100, 200]
                    }"
                    :server-items-length="totalItems"
                    :must-sort="false">
        <template v-slot:no-data>
          <v-row>
            <v-col class="text-center" cols="12" v-if="loading">
              {{ $t('general.loadingUsers') }}
            </v-col>
            <v-col cols="12" class="red--text text-center" v-else>
              {{ $t('general.noPeopleInThisList') }}
            </v-col>
          </v-row>
        </template>
        <template v-if="type === 'massive'" v-slot:item="{ item }">
          <tr>
            <td>
              <v-icon v-if="item.sentStatus === 'not_interested'" color="error">not_interested</v-icon>
              <v-icon v-if="item.sentStatus === 'done_all'" color="success">done_all</v-icon>
              <v-icon v-if="item.sentStatus === 'timer'" color="warning">timer</v-icon>
              <v-icon v-if="item.sentStatus === 'done'" color="success">done</v-icon>
            </td>
            <td class="font-weight-bold">{{ `+${item.countryCode} ${item.phoneNumber}` }}</td>
            <td>{{ item.info ? item.info.message : $t('general.noMessage') }}</td>
            <td>
              <template v-if="item.info.result && item.info.result.numparts"> {{ item.info.result.numparts }} </template>
              <template v-else-if="item.info.calculatedMultiparts">
                {{ item.info.calculatedMultiparts }}
              </template>
              <template v-else> n/a </template>
            </td>
          </tr>
        </template>

        <template v-slot:item="{ item }" v-else>
          <tr>
            <td>
              <v-tooltip v-if="item.responseStatus === 'pending'" bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="warning">timer</v-icon>
                </template>
                <span>{{ $t('general.pending') }}</span>
              </v-tooltip>
              <v-tooltip bottom v-else-if="item.responseStatus === 'deferral'">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="info">
                  hourglass_empty</v-icon>
                </template>
                <span>{{ $tc('general.postponed', 0) }}</span>
              </v-tooltip>
              <v-tooltip bottom v-else-if="item.responseStatus === 'unsub'">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="error">
                  unsubscribe</v-icon>
                </template>
                <span>{{ $tc('general.terminated', 0) }}</span>
              </v-tooltip>
              <v-tooltip bottom v-else-if="item.responseStatus === 'whitelist'">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="info">insert_drive_file</v-icon>
                </template>
                <span>{{ $t('general.inWhiteList') }}</span>
              </v-tooltip>
              <v-tooltip bottom v-else-if="item.responseStatus === 'blacklist'">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="error">insert_drive_file</v-icon>
                </template>
                <span>{{ $t('general.inBlackList') }}</span>
              </v-tooltip>
              <v-tooltip bottom v-else-if="item.responseStatus === 'open'">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="success">drafts</v-icon>
                </template>
                <span>{{ $tc('general.opened', 0) }}</span>
              </v-tooltip>
              <v-tooltip bottom v-else-if="item.responseStatus === 'click'">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="success">mouse</v-icon>
                </template>
                <span>{{ $t('general.clicked') }}</span>
              </v-tooltip>
              <v-tooltip bottom v-else-if="item.responseStatus === 'spam'">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="error">report</v-icon>
                </template>
                <span>{{ $t('general.inSpam') }}</span>
              </v-tooltip>
              <v-tooltip bottom v-else-if="item.responseStatus === 'hard_bounce'">
                <template v-slot:activator="{ on }">
                  <v-icon color="error" v-on="on">call_missed_outgoing</v-icon>
                </template>
                <span>{{ $tc('general.hardRebound', 0) }}</span>
              </v-tooltip>
              <v-tooltip bottom v-else-if="item.responseStatus === 'soft_bounce'">
                <template v-slot:activator="{ on }">
                  <v-icon color="info" v-on="on">call_missed_outgoing</v-icon>
                </template>
                <span>{{ $tc('general.softRebound', 0) }}</span>
              </v-tooltip>
              <v-tooltip bottom v-else-if="item.responseStatus === 'rejected'">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="error">not_interested</v-icon>
                </template>
                <span>{{ $tc('general.rejected', 0) }}</span>
              </v-tooltip>
              <v-tooltip bottom v-else-if="item.responseStatus === 'delivered'">
                <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="success">done_all</v-icon>
                </template>
                <span>{{ $tc('general.sent', 1) }}</span>
              </v-tooltip>
              <v-tooltip bottom v-else-if="item.status === 'sent' || item.responseStatus === 'sent'">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="success">done</v-icon>
                </template>
                <span>{{ $tc('general.sent', 1) }}</span>
              </v-tooltip>
            </td>
            <td class="font-weight-bold text-capitalize">{{ item.name }}</td>
            <td>{{ item.email ? item.email : 'n/a' }}</td>
            <td>{{ item.phoneNumber ? `+${item.countryCode || ''} ${item.phoneNumber || ''}` : 'n/a' }}</td>
            <td v-if="showMessageType">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon color="kbDarkBlueText" v-on="on" style="cursor:pointer;">
                    {{ getIconType(item.type) }}
                  </v-icon>
                </template>
                <span style="text-transform: capitalize">{{item.type}}</span>
              </v-tooltip>
            </td>
            <td class="px-0 mx-0">
              <div class="data-table-actions d-flex justify-center align-center">
                <v-btn icon @click="showUserMsg(item)" color="kbDarkBlueText">
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>
<script>
import messageTypes from '@/libs/messageTypes'
export default {
  computed: {
    defaultHeaders () {
      const defaultHeaders = [
        { text: '', align: 'left', sortable: false },
        { text: this.$t('general.name'), align: 'left', sortable: false },
        { text: 'Email', align: 'left', sortable: false },
        { text: this.$t('general.phone'), align: 'left', sortable: false },
        { text: this.$t('general.actions'), align: 'center', sortable: false }
      ]
      if (this.showMessageType) {
        defaultHeaders.push(
          { text: this.$t('general.type'), value: 'description' }
        )
        defaultHeaders.push(
          { text: this.$t('general.message'), align: 'center', sortable: false }
        )
      }
      return defaultHeaders
    },
    smsMassiveHeaders () {
      return [
        { text: '', align: 'left', sortable: false },
        { text: this.$t('general.phone'), align: 'left', sortable: false },
        { text: this.$t('general.message'), align: 'left', sortable: false },
        { text: this.$t('general.multiParts'), align: 'center', sortable: false }
      ]
    },
    optionsValue: {
      get () {
        return this.pagination
      },
      set (value) {
        this.$emit('setPagination', value)
      }
    }
  },
  data () {
    return {
      selectedUserSentMessage: {},
      dialogUsrMsg: false,
      getIconType: messageTypes.getIconType
    }
  },
  methods: {
    showUserMsg (person) {
      try {
        if (person.type === 'email') {
          const newWindow = window.open()
          newWindow.document.title = 'Preview Message'
          newWindow.document.write(person.message || '')
          newWindow.stop()
        } else {
          this.selectedUserSentMessage = person
          this.dialogUsrMsg = true
        }
      } catch (err) {
        console.log(err)
      }
    }
  },
  props: ['items', 'totalItems', 'type', 'pagination', 'loading', 'showMessageType']
}
</script>
